import script from "./BottomSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomSheet.vue?vue&type=script&setup=true&lang=js"

import "./BottomSheet.vue?vue&type=style&index=0&id=b34932aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b34932aa"]])

export default __exports__